const doc = [({"en":({"adminConstantHotelBillingType":({"free":"Free plan", "paid":"Paid plan"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;